export function groupArray(arr, key, nestedKey = "data") {
  const map = {};
  arr
    .map((e) => ({ k: key(e), d: e }))
    .forEach((e) => {
      map[e.k] = map[e.k] || [];
      map[e.k].push(e.d);
    });

  return Object.keys(map).map((k) => ({ key: k, [nestedKey]: map[k] }));
}
